import type { IconSvgObject } from './types';

const FolderAudioIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V10M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 15.5H15.5C15.2239 15.5 15 15.7239 15 16V18C15 18.2761 15.2239 18.5 15.5 18.5H18L22 21V13L18 15.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderAudioIcon;
